import type { VariantType } from '../../../types';
import styles from './CommonLoading.module.scss';
import raffleStyles from './CommonLoading.raffle.module.scss';

export interface CommonLoadingProps {
  variant?: VariantType;
}

function CommonLoading({ variant = 'default' }: CommonLoadingProps) {
  // variantに応じてスタイルを決定
  // --color-primaryを使っているので分ける
  const currentStyles = variant === 'raffle' ? raffleStyles : styles;

  return (
    <div className={currentStyles.componentStyle}>
      <div />
      <div />
    </div>
  );
}

export default CommonLoading;
